import { createFileRoute } from '@tanstack/react-router';
import { AGGREGATE_NAMES, LOAN_REQUEST_RESOLVERS, USER_LEAD_CARRYING_ROLES } from 'cpool-constants';
import {
    schemaLoanRequestResolver_GetLoanRequestsWithUnverifiedDocuments,
    schemaLoanRequestResolver_GetResubmissionLoanRequestsByDate,
} from 'cpool-tables/backend-resolvers';

import { authoriseUser } from '~/features/auth/utils/authoriseUser';
import { DashboardView } from '~/features/dashboard';
import { dashboardSearchSchema } from '~/features/dashboard/dashboardSearch';
import { getQueryOptions } from '~/queryUtils/getQueryOptions';

const isoDateString = new Date().toISOString().slice(0, 10);

const loanRequestResubmissionQueryOptions = () =>
    getQueryOptions({
        aggregateName: AGGREGATE_NAMES.LOAN_REQUEST,
        resolverName: LOAN_REQUEST_RESOLVERS.getResubmissionLoanRequestsByDate,
        schema: schemaLoanRequestResolver_GetResubmissionLoanRequestsByDate,
        searchParams: {
            resubmission: isoDateString,
        },
    });

const loanRequestNewDocumentsQueryOptions = () =>
    getQueryOptions({
        aggregateName: AGGREGATE_NAMES.LOAN_REQUEST,
        resolverName: LOAN_REQUEST_RESOLVERS.getLoanRequestsWithUnverifiedDocuments,
        schema: schemaLoanRequestResolver_GetLoanRequestsWithUnverifiedDocuments,
        searchParams: { position: null },
    });

const Dashboard = () => {
    return (
        <section className="page flex-1 bg-surface-light">
            <DashboardView />
        </section>
    );
};

export const Route = createFileRoute('/_app/dashboard/')({
    beforeLoad: ({ location }) => {
        authoriseUser([...USER_LEAD_CARRYING_ROLES], location);
        const content = 'ROUTE_TITLE.DASHBOARD';
        return {
            meta: [
                {
                    content,
                    name: 'description',
                },
                {
                    content,
                    name: 'title',
                },
            ],
        };
    },
    // eslint-disable-next-line sort/object-properties
    loaderDeps: ({ search }) => search,
    loader: async ({ context }) => [
        context.queryClient.ensureQueryData(loanRequestResubmissionQueryOptions()),
        context.queryClient.ensureQueryData(loanRequestNewDocumentsQueryOptions()),
    ],
    component: () => <Dashboard />,
    validateSearch: dashboardSearchSchema,
});
